import { render, staticRenderFns } from "./AdvertMgmtOld.vue?vue&type=template&id=554d7952"
import script from "./AdvertMgmtOld.vue?vue&type=script&lang=js"
export * from "./AdvertMgmtOld.vue?vue&type=script&lang=js"
import style0 from "./AdvertMgmtOld.vue?vue&type=style&index=0&id=554d7952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports